import { generateCodeChallenge, generateCodeVerifier } from "./pkce"; // helper PKCE Anda

export async function redirectToSso(returnTo?: string) {
  const ssoLoginUrl = import.meta.env.VITE_APP_SSO_URL;
  const clientId = import.meta.env.VITE_APP_SSO_CLIENT_ID;
  const redirectUrl = import.meta.env.VITE_APP_SSO_REDIRECT_URL;

  localStorage.removeItem("access_token");

  if (returnTo) {
    sessionStorage.setItem("post_login_redirect", returnTo);
  }

  // 1. Generate PKCE Verifier & Challenge
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  // 2. Simpan codeVerifier di sessionStorage untuk dipakasi saat exchange token nanti
  sessionStorage.setItem("pkce_code_verifier", codeVerifier);

  // 3. Sertakan codeChallenge & codeChallengeMethod ke URL query
  const queryParams = new URLSearchParams({
    clientId,
    redirectUri: redirectUrl,
    responseType: "code",
    codeChallenge,
    codeChallengeMethod: "S256",
  });

  window.location.href = `${ssoLoginUrl}/?${queryParams.toString()}`;
}
